(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  // Footer Accordion Functionality (Mobile Only)
  (function() {
    const accordionHandlers = new WeakMap();
    const ANIMATION_DURATION = 300; // milliseconds
    
    function slideToggle(element, isExpanding, callback) {
      if (!element) return;
      
      const startHeight = element.offsetHeight;
      let targetHeight;
      
      if (isExpanding) {
        // Get natural height by temporarily removing height constraint
        element.style.height = 'auto';
        element.style.overflow = 'visible';
        targetHeight = element.scrollHeight;
        element.style.height = startHeight + 'px';
        element.style.overflow = 'hidden';
        // Force reflow
        element.offsetHeight;
      } else {
        targetHeight = 0;
      }
      
      const startTime = performance.now();
      const heightDifference = targetHeight - startHeight;
      
      function animate(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / ANIMATION_DURATION, 1);
        
        // Easing function (ease-out)
        const easeProgress = 1 - Math.pow(1 - progress, 3);
        const currentHeight = startHeight + (heightDifference * easeProgress);
        
        element.style.height = currentHeight + 'px';
        
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          // Animation complete
          if (isExpanding) {
            element.style.height = 'auto';
            element.style.overflow = 'visible';
          } else {
            element.style.height = '0px';
            element.style.overflow = 'hidden';
          }
          if (callback) callback();
        }
      }
      
      requestAnimationFrame(animate);
    }
    
    function closeAccordion(toggle, content, icon) {
      if (!toggle || !content) return;
      
      toggle.setAttribute('aria-expanded', 'false');
      slideToggle(content, false, function() {
        content.classList.remove('footer-block__accordion-content--expanded');
      });
      if (icon) {
        icon.style.transition = 'transform 0.3s ease';
        icon.style.transform = 'rotate(0deg)';
      }
    }
    
    function openAccordion(toggle, content, icon) {
      if (!toggle || !content) return;
      
      toggle.setAttribute('aria-expanded', 'true');
      content.classList.add('footer-block__accordion-content--expanded');
      slideToggle(content, true);
      if (icon) {
        icon.style.transition = 'transform 0.3s ease';
        icon.style.transform = 'rotate(180deg)';
      }
    }
    
    function handleAccordionClick(event) {
      const toggle = event.currentTarget;
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      const content = toggle.nextElementSibling;
      const icon = toggle.querySelector('.icon-caret');
      
      if (!content || !content.classList.contains('footer-block__accordion-content')) return;
      
      // Close all other accordions first (accordion behavior)
      const allToggles = document.querySelectorAll('.footer-block__accordion-toggle');
      allToggles.forEach(otherToggle => {
        if (otherToggle !== toggle) {
          const otherContent = otherToggle.nextElementSibling;
          const otherIcon = otherToggle.querySelector('.icon-caret');
          
          if (otherContent && otherContent.classList.contains('footer-block__accordion-content')) {
            const otherIsExpanded = otherToggle.getAttribute('aria-expanded') === 'true';
            if (otherIsExpanded) {
              closeAccordion(otherToggle, otherContent, otherIcon);
            }
          }
        }
      });
      
      // Toggle current accordion
      if (isExpanded) {
        closeAccordion(toggle, content, icon);
      } else {
        openAccordion(toggle, content, icon);
      }
    }
    
    function initFooterAccordion() {
      const isMobile = window.innerWidth < 750;
      const accordionToggles = document.querySelectorAll('.footer-block__accordion-toggle');
      
      accordionToggles.forEach(toggle => {
        const content = toggle.nextElementSibling;
        const icon = toggle.querySelector('.icon-caret');
        
        if (!content || !content.classList.contains('footer-block__accordion-content')) return;
        
        // Check if handler already attached
        const hasHandler = accordionHandlers.has(toggle);
        
        if (isMobile) {
          // Mobile: Initialize accordion behavior
          toggle.style.display = '';
          
          // Only attach handler once
          if (!hasHandler) {
            toggle.addEventListener('click', handleAccordionClick);
            accordionHandlers.set(toggle, true);
            toggle.setAttribute('aria-expanded', 'false');
            content.style.height = '0px';
            content.style.overflow = 'hidden';
            if (icon) {
              icon.style.transition = 'transform 0.3s ease';
              icon.style.transform = 'rotate(0deg)';
            }
          } else {
            // Maintain current state on resize
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
              content.style.height = 'auto';
              content.style.overflow = 'visible';
              content.classList.add('footer-block__accordion-content--expanded');
              if (icon) icon.style.transform = 'rotate(180deg)';
            } else {
              content.style.height = '0px';
              content.style.overflow = 'hidden';
              content.classList.remove('footer-block__accordion-content--expanded');
              if (icon) icon.style.transform = 'rotate(0deg)';
            }
          }
        } else {
          // Desktop: Show content, hide toggle
          toggle.style.display = 'none';
          content.style.height = 'auto';
          content.style.overflow = 'visible';
          content.classList.remove('footer-block__accordion-content--expanded');
          if (icon) {
            icon.style.transition = '';
            icon.style.transform = 'rotate(0deg)';
          }
        }
      });
    }
    
    // Run on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFooterAccordion);
    } else {
      initFooterAccordion();
    }
    
    // Run on resize with debounce
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(initFooterAccordion, 250);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
